import { render, staticRenderFns } from "./OrthoPainCause.vue?vue&type=template&id=4a23c9c8&scoped=true"
import script from "./OrthoPainCause.vue?vue&type=script&lang=js"
export * from "./OrthoPainCause.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a23c9c8",
  null
  
)

export default component.exports